<template>
  <div>
    <v-carousel
      :continuous="true"
      cycle
      :show-arrows="false"
      hide-delimiter-background
      delimiter-icon="mdi-minus"
      height="750"
    >
      <v-carousel-item>
        <v-sheet height="50%" tile
          ><v-container>
            <div class="pt-5 pb-5 h1">
              CUSTOMER'S REVIEW <br />"Customers Say We Are Awesome"
            </div>
            <br />
            <br />
            <v-row align="center" justify="center">
              <v-col cols="12" md="12" lg="12" sm="12">
                <v-card
                  class="mx-auto card"
                  max-width="600"
                  max-height="500"
                  color="white"
                >
                  <v-img
                    src="@/assets/career5.jpg"
                    height="200px"
                    class="inner-img"
                  ></v-img>

                  <div class="pl-3 pb-3 pr-3 pt-3">
                    <h4 class="pt-3">
                      RANJAN
                      <br />
                      PR Canada
                    </h4>
                    <p>
                      "I have processed Australia PR for my self and family with
                      MyEduVisa Consutlancy. They where extremely helpful. Each
                      of my doubts where dealt with patience. All services where
                      given with professional quality. They checked all
                      documentations thoroughly throughout the process.
                      Excellent and affordable service."
                    </p>
                  </div>
                  <div class="text-left pl-3 pb-3">
                    <v-btn rounded color="green accent-4" dark>
                      <b> be one of them</b></v-btn
                    >
                  </div>
                  <br />
                </v-card>
              </v-col>
            </v-row>
          </v-container>
        </v-sheet>
      </v-carousel-item>
      <v-carousel-item>
        <v-sheet height="50%" tile
          ><v-container>
            <div class="pt-5 pb-5 h1">
              CUSTOMER'S REVIEW <br />"Customers Say We Are Awesome"
            </div>
            <br />
            <br />
            <v-row align="center" justify="center">
              <v-col cols="12" md="12" lg="12" sm="12">
                <v-card
                  class="mx-auto card"
                  max-width="600"
                  max-height="500"
                  color="white"
                >
                  <v-img
                    src="@/assets/career5.jpg"
                    height="200px"
                    class="inner-img"
                  ></v-img>
                  <div class="pl-3 pb-3 pr-3 pt-3">
                    <h4 class="pt-3">
                      RANJAN
                      <br />
                      PR Canada
                    </h4>
                    <p>
                      "I have processed Australia PR for my self and family with
                      MyEduVisa Consutlancy. They where extremely helpful. Each
                      of my doubts where dealt with patience. All services where
                      given with professional quality. They checked all
                      documentations thoroughly throughout the process.
                      Excellent and affordable service."
                    </p>
                  </div>
                  <div class="text-left pl-3 pb-3">
                    <v-btn rounded color="green accent-4" dark>
                      <b>be one of them</b></v-btn
                    >
                  </div>
                  <br />
                </v-card>
              </v-col>
            </v-row>
          </v-container>
        </v-sheet>
      </v-carousel-item>
      <v-carousel-item>
        <v-sheet height="50%" tile
          ><v-container>
            <div class="pt-5 pb-5 h1">
              CUSTOMER'S REVIEW <br />"Customers Say We Are Awesome"
            </div>
            <br />
            <br />
            <v-row align="center" justify="center">
              <v-col cols="12" md="12" lg="12" sm="12">
                <v-card
                  class="mx-auto card"
                  max-width="600"
                  max-height="500"
                  color="white"
                >
                  <v-img
                    src="@/assets/career5.jpg"
                    height="200px"
                    class="inner-img"
                  ></v-img>

                  <div class="pl-3 pb-3 pr-3 pt-3">
                    <h4 class="pt-3">
                      RANJAN
                      <br />
                      PR Canada
                    </h4>
                    <p>
                      "I have processed Australia PR for my self and family with
                      MyEduVisa Consutlancy. They where extremely helpful. Each
                      of my doubts where dealt with patience. All services where
                      given with professional quality. They checked all
                      documentations thoroughly throughout the process.
                      Excellent and affordable service."
                    </p>
                  </div>
                  <div class="text-left pl-3 pb-3">
                    <v-btn rounded color="green accent-4" dark>
                      <b>be one of them</b></v-btn
                    >
                  </div>
                  <br />
                </v-card>
              </v-col>
            </v-row>
          </v-container>
        </v-sheet>
      </v-carousel-item>
    </v-carousel>
  </div>
</template>
<script>
export default {
  data() {
    return {
      colors: ["secondary", "secondary"],
      cycle: false,
    };
  },
};
</script>
<style scoped>
h4 {
  text-align: left;
  color: black;
}
.h1 {
  text-align: center;
  font-size: 25px;
}
h2 {
  color: black;
  text-align: center;
}
p {
  color: black;
  text-align: left;
  font-size: 12px;
  padding-top: 10px;
}
.card {
  padding-top: 30px;
  padding-bottom: 30px;
  padding-right: 30px;
  padding-left: 30px;
}
.inner-img {
  transition: 0.3s;
}

.inner-img:hover {
  transform: scale(0.9);
}

/* Other styling elements, that are not necessary for the example */
</style>